export interface CartPrices {
  prices: {
    discount_amount: {
      value: boolean
      currency: boolean
      [key: string]: any
    }
    grand_total: {
      value: boolean
      currency: boolean
      [key: string]: any
    }
    applied_taxes: {
      amount: {
        currency: boolean
        value: boolean
        [key: string]: any
      }
      label: boolean
      [key: string]: any
    }
    subtotal_excluding_tax: {
      value: boolean
      currency: boolean
      [key: string]: any
    }
    subtotal_including_tax: {
      value: boolean
      currency: boolean
      [key: string]: any
    }
    subtotal_with_discount_excluding_tax: {
      value: boolean
      currency: boolean
      [key: string]: any
    }
    [key: string]: any
  }
}

export const cartPrices = {
  prices: {
    discount_amount: {
      value: true,
      currency: true
    },
    grand_total: {
      value: true,
      currency: true
    },
    applied_taxes: {
      amount: {
        currency: true,
        value: true
      },
      label: true
    },
    subtotal_excluding_tax: {
      value: true,
      currency: true
    },
    subtotal_including_tax: {
      value: true,
      currency: true
    },
    subtotal_with_discount_excluding_tax: {
      value: true,
      currency: true
    }
  }
}
